const RankingColumnsEmergingCompanies = [
  {
    name: "RANK",
    value: "rank",
    show: true,
    isBold: true,
  },
  {
    name: "COMPANY/INDUSTRY",
    value: "name",
    subvalue: "industry",
    show: true,
    isBold: true,
  },
  {
    name: "NET INCOME\n(INR CR)",
    value: "noi",
    subvalue: "noi-yoy-chg",
    show: true,
  },
  {
    name: "NET INCOME - 3YR\nCAGR (%)",
    value: "noi-3yr-cagr",
    show: true,
  },
  {
    name: "EBITDA\n(INR Cr)",
    value: "ebitda",
    subvalue: "ebitda-yoy-chg",
    show: true,
    sortable: true,
  },
  {
    name: "PROFIT\n(INR CR)",
    value: "profit",
    subvalue: "profit-yoy-chg",
    show: true,
    sortable: true,
  },
  {
    name: "PROFIT - 3YR\nCAGR(%)",
    value: "profit-3yr-cagr",
    show: true,
  },
  {
    name: "EBITDA MARGIN\n(%)",
    value: "ebitda-margin",
    show: true,
  },
  {
    name: "PROFIT MARGIN\n(%)",
    value: "profit-margin",
    show: true,
  },
  {
    name: "RONW%\n3YR AVERAGE",
    value: "ronw",
    subvalue: "ronw-3yr-avg",
    show: true,
  },
  {
    name: "ROCE%\n3YR AVERAGE",
    value: "roce",
    subvalue: "roce-3yr-avg",
    show: true,
  },
  {
    name: "TOTAL ASSETS\n(INR CR)",
    value: "assets",
    show: true,
    sortable: true,
  },
  {
    name: "RETURN ON ASSETS (%)",
    value: "return-on-assets",
    show: true,
  },
  {
    name: "TOTAL DEBT\n(INR CR)",
    value: "total-debt",
    show: true,
  },
  {
    name: "NET WORTH\n(INR CR)",
    value: "networth",
    show: true,
    sortable: true,
  },
  {
    name: "DEBT TO EQUITY RATIO",
    value: "debt-equity-ratio",
    show: true,
  },
  {
    name: "CLOSE PRICE\n(INR)",
    value: "close-price",
    show: true,
  },
  {
    name: "MARKET CAP\n(INR CR)",
    value: "market-cap",
    show: true,
    sortable: true,
  },
  {
    name: "CLOSE PRICE 3-YR CAGR",
    value: "close-price-3yr-cagr",
    show: true,
  },
  {
    name: "ENTERPRISE VALUE\n(INR CR)",
    value: "enterprice-value",
    show: true,
  },
  {
    name: "TTM PE",
    value: "ttm-pe",
    show: true,
  },
  {
    name: "TTM P/B",
    value: "ttm-pb",
    show: true,
  },
  {
    name: "MARKET CAP TO SALES RATIO",
    value: "market-cap-to-sales-ratio",
    show: true,
  },
  {
    name: "PROMOTER & GROUP HOLDINGS\n(%)",
    value: "promoter-group-holdings",
    show: true,
  },
  {
    name: "NON PROMOTER HOLDINGS\n(%)",
    value: "non-promoter-holdings",
    show: true,
  },
  {
    name: "FII HOLDINGS\n(%)",
    value: "fii-holdings",
    show: true,
  },
  {
    name: "DII HOLDINGS\n(%)",
    value: "dii-holdings",
    show: true,
  },
];

export default RankingColumnsEmergingCompanies;
